/*
 * @Description: 版本检测API服务 - 测服环境使用https://aitest.xinfushenghuo.cn，生产环境使用https://ai.xinfushenghuo.cn
 * @Date: 2025-09-08 16:10:46
 * @LastEditTime: 2026-04-22 10:21:08
 * @FilePath: \hui_ai_ui\src\api\version.js
 */
import axios from 'axios';
import { isTauri } from '@/config';

// 错误处理函数
const handleError = (error) => {
    console.error('API请求错误:', error);
    
    // 当测试环境接口不可用时，返回mock数据
    const appEnv = process.env.VUE_APP_ENV;
    const isTestEnvironment = appEnv !== 'production';
    
    if (isTestEnvironment) {
        console.log('测服环境接口不可用，使用mock版本数据');
        // 返回一个默认的版本数据对象
        return Promise.resolve({
            version: "1.0.0", // 默认版本号
            timestamp: new Date().getTime()
        });
    }
    
    return Promise.reject(error);
};

// 响应处理函数
const handleResponse = (response) => {
    return response.data;
};

// 【版本检测专用】的 Axios 实例
const versionService = axios.create({
    timeout: 60000
});

// 请求拦截器 - 使用与项目一致的环境判断逻辑
versionService.interceptors.request.use(
    config => {
        // ⚠️ isTauri 检查必须在 localhost 检查之前！
        // 因为 Tauri dev 模式下 hostname 也是 localhost，会导致误判
        if (isTauri) {
            // Tauri 环境，根据打包命令使用不同的地址
            const appEnv = process.env.VUE_APP_ENV;
            config.baseURL = appEnv === 'production' 
                ? 'https://ai.xinfushenghuo.cn'  // 生产环境
                : 'https://aitest.xinfushenghuo.cn'; // 测试环境
        } else if (window.location.hostname === 'localhost') {
            // 本地开发时使用代理路径
            config.baseURL = '/api/version'; // 本地代理路径
        } else {
            // Web 生产环境，使用实际 API 地址
            config.baseURL = `https://${window.location.host}`;
        }
        // 请求头配置
        config.headers['Accept'] = 'application/json';
        config.headers['Content-Type'] = 'application/json';
        // 注入 Authorization（后端版本接口也要求 token 了）
        const pctoken = sessionStorage.getItem('pctoken');
        if (pctoken) {
            config.headers['Authorization'] = `Bearer ${pctoken}`;
        }
        return config;
    },
    handleError
);

// 响应拦截器
versionService.interceptors.response.use(handleResponse, handleError);

// 命名导出 - 这是推荐的导入方式
export { versionService };
// 默认导出 - 为了保持兼容性
export default versionService;